import { render, staticRenderFns } from "./ClienteForm.vue?vue&type=template&id=df7b2252&scoped=true"
import script from "./ClienteForm.vue?vue&type=script&lang=js"
export * from "./ClienteForm.vue?vue&type=script&lang=js"
import style0 from "./ClienteForm.vue?vue&type=style&index=0&id=df7b2252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7b2252",
  null
  
)

export default component.exports